import { useState } from 'react';

const navLinks = ['Services', 'Work', 'About', 'Contact'];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-brand-bg border-b border-brand-gray">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="/" className="text-brand-text font-semibold text-lg tracking-tight hover:text-brand-blue transition-colors">RG Consulting</a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map(link => (
            <a key={link} href={`#${link.toLowerCase()}`} className="text-sm text-brand-text/70 hover:text-brand-blue transition-colors">
              {link}
            </a>
          ))}
        </nav>

        <button className="md:hidden p-2" onClick={() => setOpen(o => !o)} aria-label="Toggle menu">
          <span className="block w-5 h-px bg-brand-text mb-1"></span>
          <span className="block w-5 h-px bg-brand-text mb-1"></span>
          <span className="block w-5 h-px bg-brand-text"></span>
        </button>
      </div>

      {open ? (
        <div className="md:hidden border-t border-brand-gray bg-brand-bg px-6 py-4 flex flex-col gap-4">
          {navLinks.map(link => (
            <a key={link} href={`#${link.toLowerCase()}`} className="text-sm text-brand-text/70 hover:text-brand-blue transition-colors" onClick={() => setOpen(false)}>
              {link}
            </a>
          ))}
        </div>
      ) : null}
    </header>
  );
}
